import { render, staticRenderFns } from "./listado-hoja-de-piso.vue?vue&type=template&id=2f4b4d98&scoped=true&"
import script from "./listado-hoja-de-piso.vue?vue&type=script&lang=ts&"
export * from "./listado-hoja-de-piso.vue?vue&type=script&lang=ts&"
import style0 from "./listado-hoja-de-piso.vue?vue&type=style&index=0&id=2f4b4d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b4d98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VMenu,VRow,VSelect,VSpacer,VTextField})
